<template>
    <div class="way">
        <h2>联系我们</h2>
        <div class="way-content">
            <div>
                <h4>电话咨询请致电</h4>
                <p>电话&nbsp;{{wayInfo.phone}}</p>
                <span>工作时间&nbsp;:&nbsp;{{wayInfo.worktime}}</span>
                <ul>
                    <li>地址&nbsp;:&nbsp;{{wayInfo.address}}</li>
                    <li>邮箱&nbsp;:&nbsp;{{wayInfo.email}}</li>
                    <li>网址&nbsp;:&nbsp;{{wayInfo.url}}</li>
                </ul>
            </div>
            <img src="../../static/images/contact_way.png" alt="">
        </div>
        <canvas id="way-canvas"></canvas>
    </div>
</template>

<script>
export default {
    name: 'Way',
    props: {
        wayInfo: Object
    },
    methods: {
        makeCanvas () {
            var canvas = document.getElementById('way-canvas')
            var ctx = canvas.getContext('2d')
            canvas.width = document.body.clientWidth
            canvas.height = document.body.clientWidth * 0.12
            ctx.font = '800 200px "微软雅黑"'
            ctx.textBaseline = "top";
            ctx.fillStyle = "#f0f0f0"
            ctx.fillText("CONTACK",canvas.width * 0.05 , canvas.height * 0.35)
        }
    },
    mounted () {
        this.makeCanvas()
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .way
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        padding: 150px 0 0
        h2
            color: #333
            font-size: 42px
            line-height: 34px
            font-weight: 600
            margin-bottom: 100px
            text-align: center
            letter-spacing: 2px
        .way-content
            width: 60%
            margin: 0 auto
            overflow: hidden
            div
                float: left
                width: 50%
                margin-top: 18%
                h4
                    font-weight: 600
                    color: #333
                    font-size: 24px
                    letter-spacing: 1px
                    &:after
                        display: block
                        margin-top: .7em
                        content:''
                        border-bottom: 1px solid $yellow
                        width: 73px
                p
                    font-size: 38px
                    font-weight: 600
                    letter-spacing: 2px
                    color: #121212
                    margin: 44px 0 20px
                span
                    font-size: 14px
                    color: #666
                    letter-spacing: 1px
                ul
                    margin-top:2.6em
                    font-size: 16px
                    color: #333
                    margin-bottm: 20%
                    li
                        line-height: 30px
                        letter-spacing: 1px
            img
                position: relative
                float: right
                z-index: 1
                width: 48%
        #way-canvas
            background: #fafafa
            margin-top: -4%
</style>


// WEBPACK FOOTER //
// src/components/pc/ContactWay.vue